<form
  [formGroup]="form"
  (ngSubmit)="finish()"
  [class.persona-edit-form--embedded]="embeddedSinglePersonaMode"
>
  @if (embeddedSinglePersonaMode) {
    <div class="persona-edit-body">
      @for (persona of personasFormArray.controls; track persona.value.id; let i = $index) {
        @if (i === embeddedDisplayIndex) {
          <div class="persona-single-edit">
            <strong class="persona-title font-weight-bold">
              {{ title(persona, i) }}
            </strong>
            <ngx-persona-form
              [eventLegalSetup]="eventLegalSetup"
              (nameChanged)="nameChanged($event)"
              [form]="persona"
              [promoCodes]="promoCodes"
              [name]="persona.controls['name']"
              [pass_code]="persona.controls['pass_code']"
              [require_approval]="persona.controls['require_approval']"
              [maximum_registrations]="persona.controls['maximum_registrations']"
              [message]="persona.controls['success_message']"
              [regret]="persona.controls['regret_message']"
              [fields]="persona.controls['form_elements']"
              [personas]="personasFormArray"
              [availableZones]="availableZones"
              [event]="event"
              [currency_id]="persona.controls['currency_id']"
              [registration_amount]="persona.controls['registration_amount']"
              [enable_payment]="persona.controls['enable_payment']"
              [personasRegstrationCount]="personasRegisrationsCount"
              [index]="i"
              (savePersona)="finish($event)"
            />
          </div>
        }
      }
    </div>
  } @else {
    <nb-accordion cdkDropList (cdkDropListDropped)="movePersona($event)" #personaAccordionRef>
      @for (persona of personasFormArray.controls; track persona.value.id; let i = $index;) {
        <nb-accordion-item #personasRef cdkDrag class="persona-item" (collapsedChange)="collapsedChange(i)" [expanded]="persona.value.opened">
          <nb-accordion-item-header>
            <div class="persona-header justify-content-between d-flex">
              <div class="drag-title d-flex flex-row justify-content-center align-items-center" cdkDragHandle>
                <strong class="persona-title font-weight-bold">
                  {{ title(persona, i) }}
                </strong>
              </div>
              <div class="actions d-flex">
                <nb-toggle
                  *ngIf="!(persona['controls']['type'].value === 31 || persona['controls']['type'].value === 30)"
                  (change)="toggleMicetribeEvents($event, i)"
                  [formControl]="persona['controls']['show_in_events']"
                  (click)="$event.stopPropagation()"
                  >Feature on MICEtribe events</nb-toggle
                >
                <nb-actions size="small" *ngIf="persona.value.type !== 100">
                  <nb-action icon="copy" (click)="clonePersona(i, $event)"> </nb-action>
                  <nb-action icon="trash" (click)="showDeletePersonaDialog(i, $event)" [disabled]="i === 0 && personasFormArray.length === 1"> </nb-action>
                </nb-actions>
              </div>
            </div>
          </nb-accordion-item-header>
          <nb-accordion-item-body>
            <ngx-persona-form
              [eventLegalSetup]="eventLegalSetup"
              (nameChanged)="nameChanged($event)"
              *ngIf="persona.value.opened"
              [form]="persona"
              [promoCodes]="promoCodes"
              [name]="persona.controls['name']"
              [pass_code]="persona.controls['pass_code']"
              [require_approval]="persona.controls['require_approval']"
              [maximum_registrations]="persona.controls['maximum_registrations']"
              [message]="persona.controls['success_message']"
              [regret]="persona.controls['regret_message']"
              [fields]="persona.controls['form_elements']"
              [personas]="personasFormArray"
              [availableZones]="availableZones"
              [event]="event"
              [currency_id]="persona.controls['currency_id']"
              [registration_amount]="persona.controls['registration_amount']"
              [enable_payment]="persona.controls['enable_payment']"
              [personasRegstrationCount]="personasRegisrationsCount"
              [index]="i"
              (savePersona)="finish($event)"
            >
            </ngx-persona-form>
          </nb-accordion-item-body>
        </nb-accordion-item>
      }
    </nb-accordion>
    <div class="d-flex flex-row justify-content-between">
      <button nbButton status="primary" class="my-3 d-flex flex-row align-content-center" role="button" type="submit">
        Finish & Share
        <span class="fas fa-chevron-right fa-md ml-2"></span>
      </button>
    </div>
  }
</form>
